export default __webpack_public_path__ + "static/media/sidebar-4.376f42a7.jpg";